import React from 'react';
import { Modal, Spin, Icon, Table } from 'antd';

import SharedTools from '../../lib/SharedTools';

export default class AttendanceTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // columns: props.columns,
    }

  }

  componentDidMount() {
    
  }

  componentWillReceiveProps(newProps) {
    
  }

  callBack(id) {
    this.props.callBack(id)
  }

  render() {
    let { columns, data, loading } = this.props;
    return (
      <div className="attendance-table">
        <Table dataSource={data} columns={columns} pagination={false} loading={loading} rowKey={record => record.id}/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/share/AttendanceTable.jsx